export const getCashMovementsList = /* GraphQL */ `
  query GetCashMovementsList($limit: Int, $nextToken: String) {
    getCashMovementsList(limit: $limit, nextToken: $nextToken) {
      items {
        PK
        SK
        orderId
        createdAt
        valute
        gameSession
        provider_hook
        updatedAt
        amount
        provider
        username
        description
        provider_hook_event
        id
        paymentStatus
        status
        amountWinning
        contract
        note
        desk {
          station
        }
      }
      nextToken
    }
  }
`;

export const getBettingsList = /* GraphQL */ `
  query GetBettingsList {
    getBettingsList {
      items {
        PK
        SK
        orderId
        createdAt
        valute
        gameSession
        provider_hook
        updatedAt
        amount
        provider
        username
        description
        provider_hook_event
        id
        paymentStatus
        status
        amountWinning
        contract
        note
        desk {
          station
        }
      }
      nextToken
    }
  }
`;
